module.exports = __webpack_public_path__ + "img/long-covid-definitions-image-right.9072b49e.png";